var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect, _g3, _g4, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeskIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NoDesksIllustration",
    xmlns: "http://www.w3.org/2000/svg",
    width: 203.297,
    height: 164.391,
    viewBox: "0 0 203.297 164.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(-147.114 -539.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3648",
    "data-name": "Group 3648",
    transform: "translate(265.852 539.426)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(29.1 70.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M1654.258,1373.476v5.25a1.579,1.579,0,0,1-1.579,1.579h-2.836l-.232-.365a.68.68,0,0,0-1.163.025l-.2.34h-8.671a.651.651,0,0,1-.43-1.14l6.476-5.689Z",
    transform: "translate(-1626.746 -1286.931)",
    fill: "#031162"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M1614.085,1351.936l2.272,4.733a1.58,1.58,0,0,1-.74,2.107L1613.06,1360l-.367-.229a.68.68,0,0,0-1.038.526l-.03.391-7.817,3.752a.651.651,0,0,1-.88-.842l4.738-10.443Z",
    transform: "translate(-1600.307 -1271.136)",
    fill: "#031162"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M1601.718,1048.978l-8.467,48.558,6.195,33.789,8.643-1.031s-2.46-32.865-2.46-33.4,10.612-27.789,10.612-27.789l-3.782-15.85Z",
    transform: "translate(-1593.251 -1048.978)",
    fill: "#63371f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1653.7,1048.978s2.077,16.866-1.231,32.445-8.216,54.1-8.216,54.1h-8.963s.373-65.036,0-65.41-.415-7.792-4.1-10.521c-6.706-4.962-6.21-10.613-6.21-10.613Z",
    transform: "translate(-1616.508 -1048.978)",
    fill: "#8c4d2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(8.685 0.463)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 6.78,
    height: 3.397,
    transform: "translate(6.873)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1692.436,1061.392H1678.9a.2.2,0,0,1,0-.4h13.536a.2.2,0,0,1,0,.4Z",
    transform: "translate(-1664.595 -1058.25)",
    fill: "#000d41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M1692.436,1052.1H1678.9a.2.2,0,1,1,0-.4h13.536a.2.2,0,1,1,0,.4Z",
    transform: "translate(-1664.595 -1051.439)",
    fill: "#000d41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1632.248,1061.392h-6.233a.2.2,0,0,1,0-.4h6.233a.2.2,0,0,1,0,.4Z",
    transform: "translate(-1625.815 -1058.25)",
    fill: "#000d41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M1632.248,1052.1h-6.233a.2.2,0,0,1,0-.4h6.233a.2.2,0,1,1,0,.4Z",
    transform: "translate(-1625.815 -1051.439)",
    fill: "#000d41"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M1580.807,933.085l-4.244,23.155s-1.089,3.661.792,4.453,8.932,0,8.932,0l.528,1.14h1.687s1.623-3.646.779-4.669-3.522-1.319-3.522-1.319l4.073-20.458Z",
    transform: "translate(-1551.684 -893.08)",
    fill: "#febac7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M1605.786,868.272s20.852-1.06,22.013,0,10.365,17.974,10.365,17.974-.58,1.244-3.482,1.99-12.707,2.239-12.707,2.239l2.087,25.182a.982.982,0,0,1-.983,1.063l-29.807-.129a1,1,0,0,1-.991-.961l-1.047-27.726-8.872-3.98s5.472-13.018,6.633-13.6S1605.786,868.272,1605.786,868.272Z",
    transform: "translate(-1556.166 -845.207)",
    fill: "#ff6a19"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M1672.157,905.729c1.026-3.865.18-8-1.26-11.731s-3.459-7.217-4.9-10.946-2.3-7.861-1.284-11.729a3.456,3.456,0,0,1,3.478,1.744,9.717,9.717,0,0,0,2.385-3.864,3.573,3.573,0,0,1,.774-1.248c6.059-.2,13.559-.307,14.242.317,1.161,1.06,10.365,17.975,10.365,17.975s-.58,1.244-3.483,1.99-12.706,2.239-12.706,2.239l2.087,25.182a.982.982,0,0,1-.983,1.063l-19.7-.085C1666.215,914.722,1670.78,910.914,1672.157,905.729Z",
    transform: "translate(-1613.955 -845.207)",
    fill: "#262260",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M1641.539,1135.522c1.572-20.742,6.062-59.088,6.611-61.33.692-2.826,1.384-5.8.611-8.6a11.873,11.873,0,0,0-4.83-6.283,45.812,45.812,0,0,0-7.147-3.753,103.041,103.041,0,0,1-11.8-6.5c0-.05,0-.077,0-.077h28.724s.025.208.066.6h0c.009.084.019.179.029.281,0,.017,0,.033,0,.051,0,.037.008.076.011.115s.005.057.009.086l.011.118c0,.034.006.069.01.1s.008.081.012.123.007.075.011.114.008.088.012.134.007.082.011.124.008.091.012.137.008.1.013.149.007.085.011.129.01.119.015.18l.01.12.025.312,0,.046c.007.093.015.188.022.285,0,.041.006.083.009.125.005.074.011.149.017.226,0,.045.007.092.01.138.005.075.011.152.016.229,0,.049.007.1.01.147q.007.116.015.235c0,.052.007.1.01.157.005.08.01.161.015.242,0,.053.007.105.01.159.005.088.01.177.016.267,0,.05.005.1.008.148.006.105.012.212.018.319,0,.036,0,.072.006.109q.024.44.046.907c0,.042,0,.086.006.129.005.113.01.226.015.342,0,.053,0,.108.007.162,0,.106.009.213.013.322q0,.09.007.18.006.158.011.318,0,.093.007.188c0,.108.007.217.01.327q0,.093.006.187c0,.115.007.232.01.35,0,.058,0,.116,0,.174,0,.134.007.271.01.407,0,.042,0,.084,0,.127q.012.543.019,1.108c0,.051,0,.1,0,.152l0,.415c0,.063,0,.126,0,.189,0,.129,0,.257,0,.387,0,.07,0,.14,0,.21v.6c0,.127,0,.254,0,.382,0,.072,0,.144,0,.217,0,.135,0,.271,0,.407,0,.066,0,.132,0,.2,0,.155,0,.312-.007.469,0,.048,0,.1,0,.145q-.011.622-.028,1.258c0,.058,0,.117-.005.175q-.007.228-.014.457l-.009.227c0,.138-.01.277-.015.416,0,.081-.007.163-.01.245-.005.135-.011.269-.017.4,0,.085-.008.17-.012.255-.006.135-.013.271-.02.406q-.006.126-.013.252c-.008.142-.016.284-.024.427,0,.079-.009.157-.013.236q-.014.238-.03.477-.006.095-.012.189-.043.67-.1,1.35c-.005.067-.011.135-.016.2-.013.157-.025.315-.039.473-.007.085-.015.169-.022.254q-.019.214-.038.429l-.026.272q-.019.207-.04.415-.014.139-.028.279-.022.208-.043.417c-.01.092-.02.183-.03.275q-.024.216-.049.432c-.01.087-.02.174-.03.261q-.028.24-.058.48c-.009.071-.017.142-.026.214q-.087.694-.185,1.391c-.011.075-.022.15-.033.225-.023.157-.045.314-.069.471-.013.09-.027.18-.041.27q-.033.215-.066.429l-.046.285c-.022.138-.045.276-.069.414-.016.1-.033.194-.049.29-.024.138-.048.276-.073.415l-.051.286q-.039.213-.079.427c-.017.09-.034.18-.051.271q-.045.234-.091.468c-.015.076-.03.152-.045.228q-.07.347-.143.693c-3.308,15.579-8.217,54.1-8.217,54.1Z",
    transform: "translate(-1587.418 -978.064)",
    fill: "#262260",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M1770.746,938.855c-.656.169-1.665.375-2.833.595.008-.4.4-.8,1.78-.95a8.446,8.446,0,0,0,4.536-1.634S1773.648,938.109,1770.746,938.855Z",
    transform: "translate(-1692.23 -895.851)",
    fill: "#031162"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M1638.708,805.556a41.14,41.14,0,0,1,.787,4.724c.158,1.968.473,4.251,3.149,5.117s2.283.63,2.283.63c.09,1.9-.964,2.956-1.719,4.542l4.125,3.095,5.939-3.729s-3.543-2.176-2.519-4.538a79.991,79.991,0,0,0,2.519-8.877s-1.843-3.49-5.19-4.156C1645.073,801.765,1640.646,803.879,1638.708,805.556Z",
    transform: "translate(-1597.485 -797.146)",
    fill: "#febac7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(41.223 7.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M1639.5,816.3a41.143,41.143,0,0,0-.787-4.724,11.722,11.722,0,0,1,1.547-1.1,6.482,6.482,0,0,1-.123,1.729,30.582,30.582,0,0,0,.12,4.912,6.621,6.621,0,0,0,.646,2.518,5.546,5.546,0,0,0,1.673,1.76C1639.963,820.511,1639.651,818.253,1639.5,816.3Z",
    transform: "translate(-1638.708 -810.475)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M1657.213,858.074a2.028,2.028,0,0,1,.186.331,3.32,3.32,0,0,1-.044,2.21,6.478,6.478,0,0,1-.7,1.683l-1.068-.8A15.882,15.882,0,0,0,1657.213,858.074Z",
    transform: "translate(-1651.082 -845.379)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M1650.665,834.015a1.907,1.907,0,0,0-1.883-.929c-1.341.129-2.347-.258-3.017,1.393,0,0-.284.438-.516.387a2.922,2.922,0,0,0,2.373,0c1.057-.6,1.083.2,2.167.265a2.2,2.2,0,0,0,1.547-.346S1650.613,834.5,1650.665,834.015Z",
    transform: "translate(-1602.281 -819.742)",
    fill: "#2e1b01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M1627.721,788.723a.014.014,0,0,0,.006-.012c0-.15-.036-2.718,2.182-3.525a12.614,12.614,0,0,1,4.411-.727l.008,0c.127-.068,3.48-1.856,6.333-1.245a7.137,7.137,0,0,1,4.362,3.427l0,0c.062.059,2.439,2.316,2.336,4.674a5.471,5.471,0,0,1-2.118,3.836.014.014,0,0,0,0,.02,2.709,2.709,0,0,1,.2,2.637,10.156,10.156,0,0,0-.489.969,12.367,12.367,0,0,1-2.786,3.961h0a.016.016,0,0,1-.027-.009l-.642-4.23a.016.016,0,0,1,.012-.018c.185-.035,2.008-.444,1.959-2.958-.052-2.649-1.195-2.337-1.87-2.078a1.709,1.709,0,0,0-.693.841.022.022,0,0,0,0,.006,8.6,8.6,0,0,1-.44,2.327v0a.711.711,0,0,1-.173.391h0s-.018.057-.049.154v.005c-.046.8,1.817,3.359.05,4.879-1.909,1.644-5.992,1.008-7.848,0-1.669-.906-1.285-3.482-1.19-3.993a.016.016,0,0,1,.031,0,2.276,2.276,0,0,0,2.7,1.722c.637-.148,1.538-.594,2.227-.151.56.36,1.923-.017,2.416-.171a.319.319,0,0,0,.218-.245h0a6.561,6.561,0,0,1,.762-2.958,18.769,18.769,0,0,0,.443-2.92.023.023,0,0,0,0-.008,2.456,2.456,0,0,0-.224-.417,3.5,3.5,0,0,1-.637-2.127l.031-.681a.016.016,0,0,0-.018-.017,45.836,45.836,0,0,1-5.423.539,9.312,9.312,0,0,0-3.381.755.016.016,0,0,0-.009.016l.11,1.24a.016.016,0,0,1-.022.017C1630.1,792.484,1625.644,790.416,1627.721,788.723Z",
    transform: "translate(-1589.025 -783.085)",
    fill: "#2e1b01"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M1638.041,785.808a5.84,5.84,0,0,1,.5-1.145c.073-.129.151-.254.232-.378.941-.448,3.635-1.577,5.99-1.073a7.137,7.137,0,0,1,4.363,3.427l0,0c.062.059,2.438,2.315,2.336,4.674a5.469,5.469,0,0,1-2.118,3.836.014.014,0,0,0,0,.02,2.709,2.709,0,0,1,.2,2.637,10.182,10.182,0,0,0-.489.969,12.357,12.357,0,0,1-2.782,3.956c.4,1.757,2.644,3.14,2.644,3.14l-1.372.861a5.388,5.388,0,0,0-1.567.984l-.166.1a1.351,1.351,0,0,0-.335-1.065,4.613,4.613,0,0,0-1.766-.909,7.106,7.106,0,0,1-3.251-2.667c.011-.045.022-.089.031-.135l-.124-.008a7.008,7.008,0,0,1-1.1-3.269,19.927,19.927,0,0,0-.136-2.8,2.368,2.368,0,0,0-1.746-1.97,8.408,8.408,0,0,0,1.117-4.532c-.041.008-.082.018-.123.023-1.076.141-2.252-.528-3.205-.009a6.523,6.523,0,0,0-.864.707,1.1,1.1,0,0,1-1.033.267.9.9,0,0,1-.512-.838,2.135,2.135,0,0,1,.294-.989A7.44,7.44,0,0,1,1638.041,785.808Z",
    transform: "translate(-1593.131 -783.085)",
    fill: "#febac7",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M1726.877,900.561a.2.2,0,0,1-.2-.167c-1.892-12.148.963-16.751,1.086-16.941a.2.2,0,0,1,.332.214c-.029.046-2.892,4.693-1.027,16.666a.2.2,0,0,1-.165.226Z",
    transform: "translate(-1661.522 -856.619)",
    fill: "#000d41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M1612.415,902.25a.2.2,0,0,1-.2-.181l-1.057-12.153a.2.2,0,0,1,.18-.214.194.194,0,0,1,.214.18l1.057,12.153a.2.2,0,0,1-.18.214Z",
    transform: "translate(-1577.284 -861.267)",
    fill: "#000d41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M1679.393,875.33l-3.449-1.872a.2.2,0,0,1,.188-.347l3.081,1.672,2.057-4.381a.2.2,0,0,1,.358.168Z",
    transform: "translate(-1624.713 -847.031)",
    fill: "#000d41"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M1652.782,877.024l-1.243-4.208a.2.2,0,0,1,.379-.112l1.1,3.721,2.324-1.379a.2.2,0,0,1,.2.34Z",
    transform: "translate(-1606.888 -848.698)",
    fill: "#000d41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M1668.863,887.986q-.04,0-.081,0a.976.976,0,1,1,.081,0Zm0-1.563a.585.585,0,0,0-.582.536h0a.584.584,0,0,0,.534.629.584.584,0,0,0,.095-1.164Zm-.779.52h0Z",
    transform: "translate(-1618.879 -858.573)",
    fill: "#000d41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M1668.863,897.942q-.04,0-.081,0a.981.981,0,1,1,.081,0Zm0-1.562a.585.585,0,0,0-.582.536h0a.584.584,0,1,0,.629-.534Zm-.779.52h0Z",
    transform: "translate(-1618.879 -865.874)",
    fill: "#000d41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M1662.042,942.669s-1.109,23.519-2.108,25.072-29.183,0-29.183,0-2.246,1.181-3.566.69a11.879,11.879,0,0,0-1.786-.568l-.648.91-.817-.085.435-2.189h-.435l-.476,2.273h-.96l.288-2.321h-.288l-.335,2.321h-.767l-.288-3.664s1.233-1.786,1.617-1.786a5.88,5.88,0,0,0,2.178-.066c1.022-.409,1-.114,1.672.318s4.891.624,4.891.624l19.524-2.542-.847-16.544S1654.061,941.9,1662.042,942.669Z",
    transform: "translate(-1584.58 -900.021)",
    fill: "#febac7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M1623.281,970.071c.375-.479.83-1,1.038-1A5.88,5.88,0,0,0,1626.5,969c1.022-.409,1-.114,1.671.318s4.891.624,4.891.624l19.524-2.542-.847-16.544a6.309,6.309,0,0,1,.707-.472c1.023.35,1.045.93,1.2,2.228q.616,5.225,1.234,10.449.342,2.9.686,5.8a1.569,1.569,0,0,1-1.773,2.153l-19.686,1.013a9.025,9.025,0,0,1-3.517-.282c-1.33-.476-2.418-1.569-3.81-1.805a10.59,10.59,0,0,0-2.6.125A5.212,5.212,0,0,1,1623.281,970.071Z",
    transform: "translate(-1586.172 -905.767)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(75.404 69.212)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M1796.427,1137.773h.928l1.57-95.18h-4.069Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#20c5a0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M1794.857,1042.593h4.069l-.086,4.514-3.949-2.761Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#20c5a0",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(1.77 69.212)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1520.338,1137.773h.928l1.57-95.18h-4.068Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#159a7c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M1518.768,1042.593h4.068l-.086,4.514-3.948-2.761Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#20c5a0",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M1493.2,1041.082h88.109a.864.864,0,0,0,.864-.864h0a.864.864,0,0,0-.864-.864H1493.2a.864.864,0,0,0-.864.864h0A.864.864,0,0,0,1493.2,1041.082Z",
    transform: "translate(-1497.617 -971.007)",
    fill: "#20c5a0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 49.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M1567.04,1035.675h-28.5a1.338,1.338,0,0,1-1.339-1.338h31.181A1.338,1.338,0,0,1,1567.04,1035.675Z",
    transform: "translate(-1523.047 -1016.803)",
    fill: "#e6e6e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M1545.474,1035.675h-31.346a1.339,1.339,0,0,1-1.339-1.338H1543.9C1544.158,1034.927,1544.469,1035.675,1545.474,1035.675Z",
    transform: "translate(-1505.149 -1016.803)",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(33.719 17.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M1612.01,1036.546h-1.174a.265.265,0,0,1-.264-.265h0a.264.264,0,0,1,.264-.265h1.174a.265.265,0,0,1,.265.265h0A.265.265,0,0,1,1612.01,1036.546Z",
    transform: "translate(-1610.572 -1036.016)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 0.265,
    cy: 0.265,
    rx: 0.265,
    ry: 0.265,
    transform: "translate(2.14 0)",
    fill: "#bcbec0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M1485.458,968.594h27.662a2.272,2.272,0,0,1,2.048,1.289l7.8,16.245h-31.182l-7.51-15.649A1.315,1.315,0,0,1,1485.458,968.594Z",
    transform: "translate(-1484.141 -968.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M1592.626,968.594h.829a2.271,2.271,0,0,1,2.047,1.289l7.8,16.245h-.828l-7.8-16.245A2.271,2.271,0,0,0,1592.626,968.594Z",
    transform: "translate(-1563.693 -968.594)",
    fill: "#e6e6e7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(147.114 563.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M1257.618,980.827s-8.959,22.225-7.91,26.27,12.135.749,12.135.749l-3.644-26.3Z",
    transform: "translate(-1228.498 -953.361)",
    fill: "#ffc814"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M1259.825,1014.918l-3.388-24.447c-.163.532-.3,1.059-.446,1.439q-.658,1.722-1.287,3.454-2.515,6.93-4.556,14.019c-.439,1.525-.849,3.22-.151,4.645a4.878,4.878,0,0,0,2.495,2.149A33.737,33.737,0,0,0,1259.825,1014.918Z",
    transform: "translate(-1226.48 -960.433)",
    fill: "#ffc814",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(54.373 41.989)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1029.47,1051.934h25.32l5.611-16.654H1035.08Z",
    transform: "translate(-1022.712 -1035.28)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1037.152,1052.469h21.979l4.471-12.96h-21.978Z",
    transform: "translate(-1027.963 -1038.381)",
    fill: "#20c5a0",
    opacity: 0.185
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1041.624,1039.509H1063.6l-.068.2h-21.747l-4.4,12.763h-.231Z",
    transform: "translate(-1027.963 -1038.381)",
    fill: "#14255e",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M1047.857,1091.957h25.32l.707-2.1h-25.321Z",
    transform: "translate(-1041.1 -1075.303)",
    fill: "#e6e7e8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M1029.065,1051.3h31.412l5.556-16.017h0a4.527,4.527,0,0,1,.053,3.1l-4.744,13.745a.914.914,0,0,1-.864.616h-31.412a.721.721,0,0,1-.721-.721h0A.721.721,0,0,1,1029.065,1051.3Z",
    transform: "translate(-1028.344 -1035.28)",
    fill: "#f1f2f2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M1030.576,1051.3h-2.232v1.441h2.232a.914.914,0,0,0,.864-.616l4.744-13.745a4.526,4.526,0,0,0-.052-3.1h0Z",
    transform: "translate(-998.443 -1035.28)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M1048.9,1097.129a.285.285,0,1,0,.286-.286A.286.286,0,0,0,1048.9,1097.129Z",
    transform: "translate(-1016.958 -1080.424)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M1069.115,1089.8h12.512a.594.594,0,0,0,.544-.355l.264-.6h-13.38l-.227.519A.314.314,0,0,0,1069.115,1089.8Z",
    transform: "translate(-1055.237 -1074.555)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M1050.3,1095.334c.676,0,.676,1.441,0,1.441h7.622c-.84,0-.84-1.441,0-1.441Z",
    transform: "translate(-1025.79 -1079.317)",
    fill: "#999"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 2.797,
    height: 0.551,
    rx: 0.275,
    transform: "translate(26.651 16.523)",
    fill: "gray"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(86.408 123.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M1004.657,1341.323l3.4-.784,8.823,5.355-1.466,1.121-9.1,1.338-1.418-1.855Z",
    transform: "translate(-1004.609 -1340.539)",
    fill: "#febac7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M999.171,1357.3s-2.535,3.667-5.673,3.645-8.082-.044-8.082-.044l3.624,4.741-1.528,1.168s-4.508-1.035-5.864-4.279a14.539,14.539,0,0,1-1.2-5.869l3.881-1.141s4.2,3.347,6.139,2.038,1.8-1.719,1.8-1.719S995.517,1358.628,999.171,1357.3Z",
    transform: "translate(-980.442 -1351.527)",
    fill: "#031162"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(30.519 74.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(12.192 48.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M1171,1340.651l3.177,1.442,3.758,9.613h-1.846l-8.042-4.463v-2.334Z",
    transform: "translate(-1165.549 -1340.651)",
    fill: "#eb8195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1167.038,1365.4s-4.241,1.373-6.72-.549-6.394-4.944-6.394-4.944v5.968H1152s-2.953-3.561-2.06-6.961a14.535,14.535,0,0,1,2.609-5.392l3.776,1.45s1.3,5.211,3.639,5.348,2.472-.275,2.472-.275S1163.33,1364.234,1167.038,1365.4Z",
    transform: "translate(-1149.773 -1350.09)",
    fill: "#031162"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M1109.923,1160.908s9.033,5.105,16.605,4.8a86.736,86.736,0,0,0,11.563-1.075s-5.833,2.763-7.521,7.368-4.042,34.867-4.042,34.867l5.27,1.559s17.037-40.724,18.111-45.79-7.06-5.065-9.209-5.218S1109.923,1160.908,1109.923,1160.908Z",
    transform: "translate(-1109.923 -1157.413)",
    fill: "#134294"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M1027.828,1125.178s-4.045,14.026,13.181,15.1c12.907.805,26.365-2.916,26.365-2.916s-1.535,10.656,2.456,19.986,15.2,27.031,15.2,27.031l7.981-1.559s-14.428-52.518-14.888-55.435-30.6-2.763-30.6-2.763Z",
    transform: "translate(-1000.398 -1058.805)",
    fill: "#1957c2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1092.346,1159.278c4.472,9.614,14.467,25.4,14.467,25.4l2.065-.4c1.186-6.821-8.1-18.476-6.693-31.817.478-4.517-2.569-8.8-5.064-12.594s-6.41-6.925-10.932-7.349c-3.975-.373-7.833,1.338-11.8,1.748s-8.849-1.3-9.5-5.238a7.944,7.944,0,0,1,.577-4l-15.843.446s-.041.143-.1.4c-.025.115-.053.251-.081.409a14.673,14.673,0,0,0-.233,2.5c0,.276,0,.562.019.857s.042.6.08.909c.019.155.041.312.067.47s.055.317.087.477.069.321.109.484q.03.121.063.243.066.244.146.489.04.122.082.245c.086.245.181.49.288.734q.107.244.229.487t.26.483q.139.24.294.477t.328.469a9.813,9.813,0,0,0,1.448,1.554h0a12.134,12.134,0,0,0,3.546,2.092q.172.068.349.132.48.176,1,.33a19.817,19.817,0,0,0,1.948.468,32.729,32.729,0,0,0,6.649,1.631q.314.039.628.069t.657.052c.4.025.805.038,1.2.037h.009q.309,0,.615-.013a86.72,86.72,0,0,0,11.563-1.075h0a20.189,20.189,0,0,0-3.944,2.612l-.211.183q-.164.144-.327.294l-.153.143-.16.154c-.241.235-.479.481-.708.739-.067.075-.132.151-.2.227a10.046,10.046,0,0,0-1.82,3.015c-.567,1.547-1.209,5.99-1.812,11.208q-.042.364-.084.733t-.083.742c-.014.124-.028.249-.042.374q-.062.561-.123,1.131-.04.379-.081.76t-.08.764c-.013.127-.026.255-.04.383q-.04.383-.079.767l-.039.384q-.06.595-.119,1.188-.036.364-.072.727l-.037.381q-.074.762-.146,1.513-.036.376-.071.747-.018.186-.035.371c-.058.616-.114,1.224-.169,1.819-.011.119-.021.238-.032.355-.538,5.9-.9,10.52-.9,10.52l5.27,1.559s.449-1.074,1.206-2.894l.083-.2c2.754-6.622,9.293-22.433,13.375-32.981h0a38.438,38.438,0,0,0,.81,4.333,31.428,31.428,0,0,0,1.328,4.141q.114.284.235.566c.045.1.091.211.138.318C1091.918,1158.34,1092.116,1158.779,1092.346,1159.278Z",
    transform: "translate(-1022.185 -1059.107)",
    fill: "#01051a",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3650",
    "data-name": "Group 3650",
    transform: "translate(101.808 58.9)"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166-2",
    "data-name": "Path 166",
    d: "M1796.427,1123.646h.928l1.57-81.053h-4.069Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#5f6169"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_167-2",
    "data-name": "Path 167",
    d: "M1794.857,1042.593h4.069l-.086,4.934-3.949-3.018Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#031162",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3651",
    "data-name": "Group 3651",
    transform: "translate(28.174 58.9)"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168-2",
    "data-name": "Path 168",
    d: "M1520.338,1123.646h.928l1.57-81.053h-4.068Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_169-2",
    "data-name": "Path 169",
    d: "M1518.768,1042.593h4.068l-.086,3.844-3.948-2.352Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#031162",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4875",
    "data-name": "Path 4875",
    d: "M1493.2,1041.082h88.109a.864.864,0,0,0,.864-.864h0a.864.864,0,0,0-.864-.864H1493.2a.864.864,0,0,0-.864.864h0A.864.864,0,0,0,1493.2,1041.082Z",
    transform: "translate(-1471.214 -981.318)",
    fill: "#555"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M1168.831,902.259s-2.352,2.142-2.352,4.33-2.512,6.192-5.868,4.349l-.336,3.881-6.723-1.533a11.47,11.47,0,0,0,2.241-6.429c-.118-3.36,3.956-14.536,8.524-12.722S1170.836,899.193,1168.831,902.259Z",
    transform: "translate(-1110.649 -889.645)",
    fill: "#febac7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M1183.133,963.621s-.338-9.421-20.938-15.641c-8.91-2.691-11.363,11.4-13,21.087a46.75,46.75,0,0,0,.86,18.462l-1.313,5.415c-.561,5.443,23.3,7.9,23.858,2.458,0,0-3.174-14.849,0-25.1C1176.141,958.852,1183.133,963.621,1183.133,963.621Z",
    transform: "translate(-1122.854 -929.028)",
    fill: "#ffc814"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M1105.752,994.656c1.671-5.52,10.005-3.768,9.2,1.943-.014.1-.03.2-.048.3-1.149,6.4-4.595,19.528-4.595,19.528l6.892-3.594s1.5-4.793,2.978-4.134a2.91,2.91,0,0,1,1.7,2.031s1.592-1.757,2.36-.549a2.917,2.917,0,0,1,.494,2.2s.823-1.263,1.592-.6.549,3.129.933,4.226.329,1.592-.714.933a3.883,3.883,0,0,1-1.262-2.47s.22,1.811-2.964,2.086l-3.183.274s-11.527,9.221-15.369,8.234C1100.586,1024.236,1101.433,1008.916,1105.752,994.656Z",
    transform: "translate(-1054.723 -961.043)",
    fill: "#febac7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M1165.685,886.222s-.649,4.887-7.3,3.419c-5.01-1.106,1.97,11.288-1.041,15.668h0a14.738,14.738,0,0,0-10.217-5.016c-2.854-.161-5.631-1.7-4.516-7.522a39.42,39.42,0,0,1,4.044-11.084C1151.222,873.37,1165.843,880.267,1165.685,886.222Z",
    transform: "translate(-1103.733 -877.843)",
    fill: "#1e2447"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1152.381,996.6q-.021.148-.048.3c-1.149,6.4-4.595,19.528-4.595,19.528l5.217-2.721a5.272,5.272,0,0,1,1.971,4.376c-3.323,2.489-10.784,7.731-13.729,6.974-3.183-.819-2.335-16.139,1.983-30.4C1144.851,989.136,1153.185,990.888,1152.381,996.6Z",
    transform: "translate(-1092.15 -961.043)",
    fill: "#ffc814"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M1154.923,1017.982a4.238,4.238,0,0,0-2.849.822,27.23,27.23,0,0,1-2.806,1.933,3.089,3.089,0,0,1-3.23-.076,3.621,3.621,0,0,1-1.078-2.582c-.287-3.241.719-6.448,1.859-9.5s2.438-6.091,2.773-9.326c.233-2.249-.045-6.048-1.831-7.949a4.523,4.523,0,0,0-4.582,3.349c-4.318,14.261-5.166,29.581-1.983,30.4,2.945.757,10.407-4.485,13.729-6.973C1154.925,1018.05,1154.923,1018.016,1154.923,1017.982Z",
    transform: "translate(-1092.15 -961.046)",
    fill: "#ffc814",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3649",
    "data-name": "Group 3649",
    transform: "translate(0 17.066)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 2.292,
    height: 49.992,
    transform: "translate(39.728 66.297)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M547.807,1112.847H522.815a24.494,24.494,0,0,1-13.652-16.1l-12.089-45.873a2.813,2.813,0,0,0-2.719-2.1h-8.386a2.151,2.151,0,0,0-1.093,0h0a2.154,2.154,0,0,0-1.534,2.631l12.093,45.886a26.673,26.673,0,0,0,25.775,19.862h26.6a2.153,2.153,0,1,0,0-4.307Z",
    transform: "translate(-483.269 -1048.703)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M546.143,1114.971H522.995c-6.59-2.964-13.565-8.307-15.5-15.635l-12.089-45.873a2.812,2.812,0,0,0-2.719-2.1H484.3a2.149,2.149,0,0,0-.979-.026,2.152,2.152,0,0,1,1.547-2.567h0a2.151,2.151,0,0,1,1.093,0h8.386a2.813,2.813,0,0,1,2.719,2.1l12.089,45.873a24.494,24.494,0,0,0,13.652,16.1H547.8a2.153,2.153,0,0,1,.441,4.261C548.034,1116.047,547.173,1114.971,546.143,1114.971Z",
    transform: "translate(-483.267 -1048.703)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M532.485,1381.947a29.415,29.415,0,0,1,22.5,0V1376.3c-6.514-2.517-13.6-3.583-22.5,0Z",
    transform: "translate(-502.938 -1259.059)",
    fill: "#222"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M1185.466,949.479c-.269.749-.479,1.529-.668,2.292a119.421,119.421,0,0,0-3.506,26.326c-.081,3.887.023,7.822-.856,11.61a16.023,16.023,0,0,0-.817,5.181c.011.1.025.206.041.308,3.908,3.011,15.773,4.3,20.566,2.3a15.491,15.491,0,0,0-.815-2.6,32,32,0,0,1,1.735-25.743c1.079-2.032.77-4.765,1.555-6.928s2.6-3.874,1.48-5.882c-1.885-3.369-6.828-3.775-8.521-7.1q-1.777-.65-3.806-1.265A6.039,6.039,0,0,0,1185.466,949.479Z",
    transform: "translate(-1152.512 -929.029)",
    fill: "#ffc814",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskIllustration);
export default __webpack_public_path__ + "static/media/deskIllustration.05cecdd843e61e88aa4d1f86e1bd69c6.svg";
export { ForwardRef as ReactComponent };